import type { ReactNode } from 'react'

import { useUserAuthorization } from '../context/UserAuthorizationContext'

type Props = {
  perm?: string
  children: ReactNode
  fallback?: ReactNode
}

/** 无写权限时不渲染子节点（可传 fallback 占位） */
export function UserPermGate({ perm, children, fallback = null }: Props) {
  const { hasPerm } = useUserAuthorization()
  if (!hasPerm(perm)) {
    return fallback
  }
  return children
}
